<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_inquiry"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="employeeInquiryForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Pengajuan Karyawan"
          addButton="Buat Pengajuan"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Tambah Pengajuan Karyawan Baru</h3>
          </div>

          <b-form id="employeeInquiryForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group
                    label-for="division"
                    label="Request For Division"
                  >
                    <model-select
                      id="village"
                      :options="listDivisionEmployee"
                      v-model="$v.employeeInquiryForm.division.$model"
                      :isError="$v.employeeInquiryForm.division.$invalid"
                      @input="getPosition"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>

                    <div
                      v-if="employeeInquiryForm.division === null"
                      class="invalid-feedback-custom"
                    >
                      Divisi harus di isi.
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group
                    label-for="position"
                    label="Request For Position"
                  >
                    <model-select
                      id="position"
                      :options="listPositionEmployee"
                      v-model="$v.employeeInquiryForm.position.$model"
                      :isError="$v.employeeInquiryForm.position.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>

                    <div
                      v-if="employeeInquiryForm.position === null"
                      class="invalid-feedback-custom"
                    >
                      Posisi harus di isi.
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="4">
                  <b-form-group
                    label-for="office"
                    label="Request For Head Office"
                  >
                    <model-select
                      id="village"
                      :options="listEmployeeHO"
                      v-model="$v.employeeInquiryForm.office.$model"
                      :isError="$v.employeeInquiryForm.office.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>

                    <div
                      v-if="employeeInquiryForm.office === null"
                      class="invalid-feedback-custom"
                    >
                      Tempat Kerja harus di isi.
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="reason" label="Reason">
                    <b-form-textarea
                      id="reason"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.employeeInquiryForm.reason.$model"
                      :state="!$v.employeeInquiryForm.reason.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                      >Alasan harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button
                type="button"
                size="sm"
                variant="danger"
                @click="cancelAdd"
              >
                <i class="fa fa-undo"></i> Back </b-button
              >&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.employeeInquiryForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_division",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      employee_inquiry: [],
      loading: true,
      loadingSubmitModal: false,
      listDivisionEmployee: [],
      listPositionEmployee: [],
      listPosition: [],
      listEmployeeHO: [],
      fields: [
        {
          key: "divison_name",
          label: "Nama Divisi",
          class: "width-250",
          sortable: true,
        },
        { key: "position_name", label: "Nama Posisi", class: "width-250" },
        { key: "head_office_name", label: "Kantor", class: "width-250" },
        { key: "request_by_name", label: "Pengajuan Oleh", class: "width-250" },
        { key: "request_time", label: "Tanggal Pengajuan", class: "width-250" },
        {
          key: "status_name",
          label: "Status",
          class: "width-250",
          sortable: true,
        },
        { key: "reason", label: "Reason", class: "width-300" },
        { key: "action", class: "width-50 text-center" },
      ],
      employeeInquiryForm: _interfaces.employee_inquiry,
      isEdit: false,
    };
  },
  validations: {
    employeeInquiryForm: {
      division: { required },
      position: { required },
      office: { required },
      reason: {},
      status: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.getEmployeeInquiry();
      this.getDropdown();
    },
    getEmployeeInquiry: function () {
      this.axios
        .get("web/employee_inquiry/all/")
        .then((response) => {
          this.employee_inquiry = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/dropdown/employee-inquiry/")
        .then((response) => {
          this.listDivisionEmployee = response.data.employee_division;
          this.listPosition = response.data.employee_position;
          this.listEmployeeHO = response.data.employee_head_office;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPosition: function (event) {
      this.listPositionEmployee = this.listPosition.filter(
        (x) => x.division_id === event
      );
    },
    editForm: function (e) {
      this.isEdit = true;
      this.resetForm();
      this.employeeInquiryForm = e;
    },
    resetForm: function () {
      for (var a in _interfaces.employee_inquiry) {
        _interfaces.employee_inquiry[a] = null;
      }
      this.employeeInquiryForm = _interfaces.employee_inquiry;
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan pengajuan karyawan ini?")) {
        this.loadingSubmitModal = true;
        this.axios
          .post("web/employee_inquiry/add/", this.employeeInquiryForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Pengajan Berhasil",
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: "Tambah Pengajan Gagal",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAdd();
            this.init();
          });
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

  